import { Box, FormControl, Input, Textarea, FormLabel, FormHelperText, useColorModeValue } from '@chakra-ui/react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useEffect, useState } from 'react';

// Assets
import { formatDate } from 'services/Utils';

// Components

const EditPhone = ({ 
  id, 
  label, 
  type = 'text', 
  value, 
  editMode,
  isActive,
  isValid, 
  onChange, 
  placeholder = '',
  mt,
  mb,
  display,
  ...restProps
}) => {
  const editLineBgDark = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #9EDFFF 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  const editLineBgWhite = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #38A9E1 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  const editLineBg = useColorModeValue(editLineBgWhite, editLineBgDark);

  const formatPhoneNumber = (number) => {
    if (!number) { return ''; }
    return number.startsWith('+') ? number : `+${number.trim()}`;
  };

  const [phoneValue, setPhoneValue] = useState(formatPhoneNumber(value));

  useEffect(() => {
    if (value && value !== phoneValue) {
      setPhoneValue(formatPhoneNumber(value));
    }
  }, [value]);

  const handlePhoneChange = (newValue) => {
    setPhoneValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <FormControl variant={editMode ? 'phone' : 'calmPhone'} id={id} mt={mt} mb={mb} display={display}>
      <PhoneInput
        international
        countryCallingCodeEditable={false}
        defaultCountry="US"
        value={phoneValue}
        onChange={handlePhoneChange}
        mb='24px'
        pt='15px'
        type='text'
        placeholder=''
        autoComplete="off"
        color='gray.200'
        className={isValid ? 'input-valid' : 'input-invalid'}/>
      <FormHelperText top="2px" className={isValid ?  'hidden' : 'input-error'}>This phone does not exist</FormHelperText>

      { editMode && (
          <Box
            zIndex="1"
            transition="0.2s all"
            opacity={ value?.length > 0 ? '1' : '0'}
            w="100%"
            position="absolute"
            bottom="0"
            h="2px" 
            bg={editLineBg} />
      )}
    </FormControl>
  );
};

export default EditPhone;